export const TRIAL_MANAGEMENT_MODULE = 'TRIAL_OVERVIEW';
export const PORTFOLIO_MANAGEMENT_MODULE = 'PORTFOLIO_HEALTH';
export const SITE_HEALTH_MODULE = 'SITE_HEALTH';
export const COUNTRY_MANAGEMENT_MODULE = 'COUNTRY_OVERVIEW';
